module.exports = "/static/media/meetings-image.f4c5a25c.jpg";